module.exports = __webpack_public_path__ + "img/gw.a6a082d0.png";